import { useEffect, useState } from "react"

import mediaBreakpoints from "./mediaBreakpoints"

/**
 * Effect hook to check matchmedia against a given breakpoint.
 * Reruns on screen width change
 * @param  {String} [media="767px"]             a valid css width unit
 * @param  {String} [matchCriteria="max-width"] a valid css media query crireria
 * @return {Boolean}                            matches true/false
 */
export function useMatchMedia(media = mediaBreakpoints.MOBILE.MAX, matchCriteria = "max-width") {
  const [matches, setMatches] = useState(false)

  useEffect(() => {
    /**
     * use browser's matchMedia to verify current screenwidth
     * @return {void}
     */
    function checkMedia() {
      setMatches(window.matchMedia(`(${matchCriteria}: ${media})`).matches)
    }
    checkMedia()
    window.addEventListener("resize", checkMedia)
    return () => {
      window.removeEventListener("resize", checkMedia)
    }
  }, [matchCriteria, media])
  return matches
}

export default useMatchMedia
